import axiosInstance from "../../apiAxios/axiosInstance";


export const createSubscriptionPlan = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/subscription-plan-store",
    payload
  );
  return response.data;
};
export const createCustomSubscriptionPlan = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/counstom-assign-plan-to-vendor",
    payload
  );
  return response.data;
};

export const getPlanList = async (payload) => {
  const response = await axiosInstance.post("/admin/subscription-plan-list",payload);
  return response.data;
};
export const ActivePlanList = async (payload) => {
  const response = await axiosInstance.post("/admin/active-subscription-plan-list",payload);
  return response.data;
};
export const AsignPlanVendorList = async (payload) => {
  const response = await axiosInstance.post("/admin/vendor-subscriptions-list",payload);
  return response.data;
};
export const asignPlantoVendor = async (payload) => {
  const response = await axiosInstance.post("/admin/assign-plan-to-vendor",payload);
  return response.data;
};

export const getSubscriptionPlanDetails = async (id) => {
  const response = await axiosInstance.post(
    "/admin/subscription-plan-show",
    { id }
  );
  return response.data;
};
export const vewVendorPlanDetails = async (paylaod) => {
  const response = await axiosInstance.post(
    "/admin/vendor-subscription-view",
    paylaod
  );
  return response.data;
};
export const ViewPlanlistByVendor = async (paylaod) => {
  const response = await axiosInstance.post(
    "/admin/vendor-all-plans",
    paylaod
  );
  return response.data;
};

export const updateSubscriptionPlan = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/subscription-plan-update",
    payload
  );
  return response.data;
};

export const updatePlanStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/subscription-plan-status-update",
    payload
  );
  return response.data;
};

export const deletePlan = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/subscription-plan-delete",
    payload
  );
  return response.data;
};


export const upgradeSubscription = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/upgrade-subscription",
    payload
  );
  return response.data;
};

export const renewSubscription = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/renew-subscription",
    payload
  );
  return response.data;
};


